module.exports = __webpack_public_path__ + "img/top-laptop.6c812c08.svg";